module.exports = __webpack_public_path__ + "static/media/my-account-withdrawal.b342fdd1.svg";